export default __webpack_public_path__ + "static/media/thumbnail_blog_14.c7ceb225.png";